module.exports = __webpack_public_path__ + "img/dinied-gray.a8f6d280.svg";